#import "../fragments/lead-summary-fragment.graphql"

mutation UpdateLeadSummary($lead: UpdateLeadInputFieldInput!) {
    updateLead(input: {lead: $lead}) {
        lead {
            ...LeadSummaryFragment
        }
    }
}
